// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  font-family: Arial, sans-serif;
  max-width: 2000px;
  margin: auto;
  padding: 20px;
}

.content-container {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.job-list {
  width: 600%;
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 5px;
}

.alert-bar {
  background-color: #f0f8ff;
  border: 1px solid #0073b1;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}

.toggle-alert {
  background-color: #0073b1;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 3px;
}

.job-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}

.job-info {
  cursor: pointer;
}

.job-info h3 {
  color: #0073b1;
  margin: 0;
}

.x-btn {
  background: rgb(233, 231, 231);
  color: rgb(7, 0, 0);
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 26px;
}

.x-btn:hover{
  background-color: inherit;
}

.job-list,
.job-details,
.job-details-placeholder {
  width: 45%; /* Slightly smaller width */
  height: 400px; /* Reduced height */
  background: #ffffff;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto; /* Handle content overflow */
  box-sizing: border-box;
}

.content-container {
  display: flex;
  gap: 20px;
}

.job-list {
  display: flex;
  flex-direction: column;
}

.job-details-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 16px;
  text-align: center;
}

.job-details, .job-details-placeholder {
  flex: 1.5 1;
  background: #ffffff;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  min-height: 400px; /* Ensures a consistent height */
  overflow-y: auto; /* Adds scroll if content overflows */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.job-details {
  justify-content: flex-start; /* Align content to the top for job details */
  align-items: flex-start;
}

.job-details-placeholder {
  justify-content: center; /* Center content for placeholder */
  color: #666;
  text-align: center;
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.easy-apply {
  background-color: #0073b1;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.save-job {
  background-color: #f6efef;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}

.alert-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  font-family: Arial, sans-serif;
  font-size: 12px;
}

.alert-content {
  display: flex;
  flex-direction: column;
}

.alert-title {
  font-weight: bold;
}

.alert-count {
  font-size: 12px;
}

.alert-actions {
  display: flex;
  align-items: center;
}

.alert-toggle {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.alert-toggle:hover{
  background-color: inherit;
}

.toggle-text {
  margin-right: 9px;
}

.toggle-icon {
  width: 30px;
  height: 15px;
  border-radius: 15px;
  background-color: #fff;
  position: relative;
  transition: background-color 0.3s ease;
}

.toggle-icon::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #007bff;
  transition: left 0.3s ease;
}

/* When the alert is on, change the background and move the toggle */
.toggle-icon.on {
  background-color: #300b7e;
}

.toggle-icon.on::before {
  left: 17px; /* Move the toggle button to the right */
}

.toggle-icon.off {
  background-color: #ccc;
}

.toggle-icon.off::before {
  left: 2px;
}

.apply-btn {
  background-color: #0073b1;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 14px;
}
  
/* Modal styling */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 400px;
  max-width: 90%;
  border-radius: 5px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
}

.modal-content h2 {
  margin-top: 0;
}

.modal-content form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-content label {
  font-weight: bold;
}

.modal-content input,
.modal-content textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal-content button {
  background-color: #0073b1;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal-content button.close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.modal-content button.close:hover {
  color: #333;
}

/* Shared button styles */
.button {
  background-color: #0073b1; /* Same color for both buttons */
  color: white; /* White text */
  border: none; /* Remove borders */
  padding: 10px 20px; /* Same padding for uniform size */
  border-radius: 5px; /* Rounded corners */
  font-size: 14px; /* Consistent font size */
  cursor: pointer; /* Pointer cursor on hover */
  transition: background-color 0.3s ease; /* Smooth hover effect */
}

.button:hover {
  background-color: #005a8c; /* Slightly darker color on hover */
}

/* Optional: Add margin if needed */
.button + .button {
  margin-left: 10px; /* Space between buttons */
}

@media (max-width: 768px) {
 .hole-container{
    margin-top: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Jobs.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU,EAAE,2BAA2B;EACvC,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB,EAAE,4BAA4B;EAC9C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB,EAAE,qCAAqC;EACvD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B,EAAE,6CAA6C;EAC1E,uBAAuB;AACzB;;AAEA;EACE,uBAAuB,EAAE,mCAAmC;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU,EAAE,wCAAwC;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,YAAY,EAAE,eAAe;EAC7B,YAAY,EAAE,mBAAmB;EACjC,kBAAkB,EAAE,kCAAkC;EACtD,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,yBAAyB;EAC1C,eAAe,EAAE,4BAA4B;EAC7C,sCAAsC,EAAE,wBAAwB;AAClE;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA,mCAAmC;AACnC;EACE,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA;CACC;IACG,iBAAiB;EACnB;AACF","sourcesContent":[".app-container {\n  font-family: Arial, sans-serif;\n  max-width: 2000px;\n  margin: auto;\n  padding: 20px;\n}\n\n.content-container {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.job-list {\n  width: 600%;\n  background: #fff;\n  border: 1px solid #ddd;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.alert-bar {\n  background-color: #f0f8ff;\n  border: 1px solid #0073b1;\n  padding: 10px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 5px;\n}\n\n.toggle-alert {\n  background-color: #0073b1;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 3px;\n}\n\n.job-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  padding: 10px 0;\n}\n\n.job-info {\n  cursor: pointer;\n}\n\n.job-info h3 {\n  color: #0073b1;\n  margin: 0;\n}\n\n.x-btn {\n  background: rgb(233, 231, 231);\n  color: rgb(7, 0, 0);\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 26px;\n}\n\n.x-btn:hover{\n  background-color: inherit;\n}\n\n.job-list,\n.job-details,\n.job-details-placeholder {\n  width: 45%; /* Slightly smaller width */\n  height: 400px; /* Reduced height */\n  background: #ffffff;\n  border: 1px solid #ddd;\n  padding: 15px;\n  border-radius: 5px;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);\n  overflow-y: auto; /* Handle content overflow */\n  box-sizing: border-box;\n}\n\n.content-container {\n  display: flex;\n  gap: 20px;\n}\n\n.job-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.job-details-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #666;\n  font-size: 16px;\n  text-align: center;\n}\n\n.job-details, .job-details-placeholder {\n  flex: 1.5;\n  background: #ffffff;\n  border: 1px solid #ddd;\n  padding: 15px;\n  border-radius: 5px;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);\n  min-height: 400px; /* Ensures a consistent height */\n  overflow-y: auto; /* Adds scroll if content overflows */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.job-details {\n  justify-content: flex-start; /* Align content to the top for job details */\n  align-items: flex-start;\n}\n\n.job-details-placeholder {\n  justify-content: center; /* Center content for placeholder */\n  color: #666;\n  text-align: center;\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.easy-apply {\n  background-color: #0073b1;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n.save-job {\n  background-color: #f6efef;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.alert-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #007bff;\n  color: #fff;\n  padding: 10px 20px;\n  font-family: Arial, sans-serif;\n  font-size: 12px;\n}\n\n.alert-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.alert-title {\n  font-weight: bold;\n}\n\n.alert-count {\n  font-size: 12px;\n}\n\n.alert-actions {\n  display: flex;\n  align-items: center;\n}\n\n.alert-toggle {\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.alert-toggle:hover{\n  background-color: inherit;\n}\n\n.toggle-text {\n  margin-right: 9px;\n}\n\n.toggle-icon {\n  width: 30px;\n  height: 15px;\n  border-radius: 15px;\n  background-color: #fff;\n  position: relative;\n  transition: background-color 0.3s ease;\n}\n\n.toggle-icon::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #007bff;\n  transition: left 0.3s ease;\n}\n\n/* When the alert is on, change the background and move the toggle */\n.toggle-icon.on {\n  background-color: #300b7e;\n}\n\n.toggle-icon.on::before {\n  left: 17px; /* Move the toggle button to the right */\n}\n\n.toggle-icon.off {\n  background-color: #ccc;\n}\n\n.toggle-icon.off::before {\n  left: 2px;\n}\n\n.apply-btn {\n  background-color: #0073b1;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n  font-size: 14px;\n}\n  \n/* Modal styling */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #fff;\n  padding: 20px;\n  width: 400px;\n  max-width: 90%;\n  border-radius: 5px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.modal-content h2 {\n  margin-top: 0;\n}\n\n.modal-content form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.modal-content label {\n  font-weight: bold;\n}\n\n.modal-content input,\n.modal-content textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.modal-content button {\n  background-color: #0073b1;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.modal-content button.close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #999;\n  cursor: pointer;\n}\n\n.modal-content button.close:hover {\n  color: #333;\n}\n\n/* Shared button styles */\n.button {\n  background-color: #0073b1; /* Same color for both buttons */\n  color: white; /* White text */\n  border: none; /* Remove borders */\n  padding: 10px 20px; /* Same padding for uniform size */\n  border-radius: 5px; /* Rounded corners */\n  font-size: 14px; /* Consistent font size */\n  cursor: pointer; /* Pointer cursor on hover */\n  transition: background-color 0.3s ease; /* Smooth hover effect */\n}\n\n.button:hover {\n  background-color: #005a8c; /* Slightly darker color on hover */\n}\n\n/* Optional: Add margin if needed */\n.button + .button {\n  margin-left: 10px; /* Space between buttons */\n}\n\n@media (max-width: 768px) {\n .hole-container{\n    margin-top: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
